<nav aria-label="navigation" class="col-12">
  <span class="anchor-content">FONCTIONS</span>
  <nav aria-label="navigation" class="nav nav-pills flex-column">
    <span class="anchor-item" [ngClass]="{active: activeJobCode == job.code || !activeJobCode && i == 0}"
          *ngFor="let job of distinctJobs$ | async; index as i" (click)="scrollToJob(job.code)">{{job.label}}</span>
  </nav>
</nav>
